import * as BRANCH_TYPES from './actionTypes';
import {
  IClearBranchList,
  IFetchBranchListFailure,
  IFetchBranchListRequest,
  IFetchBranchListSuccess,
  IFetchBranchListSuccessPayload
} from './types';

export const fetchBranchListRequest = ({
  chiefdomId,
  successCb,
  failureCb
}: Omit<IFetchBranchListRequest, 'type'>): IFetchBranchListRequest => ({
  type: BRANCH_TYPES.FETCH_BRANCH_LIST_REQUEST,
  chiefdomId,
  successCb,
  failureCb
});

export const fetchBranchListSuccess = (payload: IFetchBranchListSuccessPayload): IFetchBranchListSuccess => ({
  type: BRANCH_TYPES.FETCH_BRANCH_LIST_SUCCESS,
  payload
});

export const fetchBranchListFailure = (error: Error): IFetchBranchListFailure => ({
  type: BRANCH_TYPES.FETCH_BRANCH_LIST_FAILURE,
  error
});

export const clearBranchList = (): IClearBranchList => ({
  type: BRANCH_TYPES.CLEAR_BRANCH_LIST
});
